var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globalG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18.3636V14V11.8182V9.63636C16 8.73263 15.2725 8 14.375 8H4.625C3.72754 8 3 8.73262 3 9.63636V11.8182V14V18.3636C3 19.2674 3.72754 20 4.625 20H14.375C15.2725 20 16 19.2674 16 18.3636Z",
    stroke: "#101223",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16H18.375C19.2725 16 20 15.2674 20 14.3636V10V7.81818V5.63636C20 4.73263 19.2725 4 18.375 4H8.625C7.72754 4 7 4.73262 7 5.63636V7.81818",
    stroke: "#101223",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "success"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18.3636V14V11.8182V9.63636C16 8.73263 15.2725 8 14.375 8H4.625C3.72754 8 3 8.73262 3 9.63636V11.8182V14V18.3636C3 19.2674 3.72754 20 4.625 20H14.375C15.2725 20 16 19.2674 16 18.3636Z",
    stroke: "#101223",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16H18.375C19.2725 16 20 15.2674 20 14.3636V10V7.81818V5.63636C20 4.73263 19.2725 4 18.375 4H8.625C7.72754 4 7 4.73262 7 5.63636V7.81818",
    stroke: "#101223",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1282 11.1202C13.2861 11.2255 13.3288 11.439 13.2235 11.5969L9.09852 17.7844C9.04139 17.8701 8.94886 17.9257 8.84637 17.9358C8.74389 17.946 8.64225 17.9096 8.56943 17.8368L5.81943 15.0868C5.68519 14.9526 5.68519 14.7349 5.81943 14.6007C5.95367 14.4664 6.17133 14.4664 6.30557 14.6007L8.75907 17.0542L12.6515 11.2156C12.7568 11.0576 12.9702 11.0149 13.1282 11.1202Z",
    fill: "#101223",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "failure"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18.3636V14V11.8182V9.63636C16 8.73263 15.2725 8 14.375 8H4.625C3.72754 8 3 8.73262 3 9.63636V11.8182V14V18.3636C3 19.2674 3.72754 20 4.625 20H14.375C15.2725 20 16 19.2674 16 18.3636Z",
    stroke: "#101223",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16H18.375C19.2725 16 20 15.2674 20 14.3636V10V7.81818V5.63636C20 4.73263 19.2725 4 18.375 4H8.625C7.72754 4 7 4.73262 7 5.63636V7.81818",
    stroke: "#101223",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 17.25L12.25 11.75M6.75 11.75L12.25 17.25",
    stroke: "#101223",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.16e427ece66b3e70657f1dd1ce372377.svg";
export { ForwardRef as ReactComponent };